import type { AllRouteEndpoints } from "../routeTypes";
export const companiesCompanyIdAppGroupPermissionSetsUpdatePermissionSetCacheKeys: AllRouteEndpoints[] = [];
